<template>
  <Datepicker
      v-model="localValue"
              locale="sk"
              :cancelText="$t('datepicker.cancel')"
              :selectText="$t('datepicker.choose')"
              :enableTimePicker="false"
              :min-date="minDate"
              :max-date="maxDate"
              :preventMinMaxNavigation="false"
              :textInput="textInput"
              :disabled="disabled"
              format="d.M.yyyy"
              :input-class-name="'w-input w-in cb_trv in in_trv ' + (error ? 'is-invalid': '') + ' ' + className"
              auto-apply

  >

  </Datepicker>
  <div :class="{'invalid-feedback': true, 'd-block': error}" >{{$t("validation.required") }}</div>
</template>

<script>
import Datepicker from "@vuepic/vue-datepicker";
export default {
  name: "DatePickerWrap",
  emits: ["input"],
  props: {
    className: {
      type: String,
      default: ""
    },
    value: String,
    minDate: null,
    maxDate: null,
    error: null,
    disabled: {
      type: Boolean,
      default: false
    },
    textInput: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Datepicker
  },
  data: function (){
    return {
      localValue: null,
      isSyncingFromProp: false,
    }
  },
  created() {
    this.syncFromProp(this.value);
  },
  methods: {
    updateLocalValue($event) {
      alert("update local value");
      this.localValue = $event.target.value
    },
    toString(date){
      if (!date) return null;
      return date.toLocaleDateString('sv-SE');
    },
    toDate(value){
      if (!value) return null;
      const s = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)
          ? value.split('T')[0]
          : null;
      if (s) {
        const [y, m, day] = s.split('-').map(Number);
        return new Date(y, m - 1, day);
      }
      return new Date(value);
    },
    syncFromProp(value) {
      if (value === this.toString(this.localValue)) return;
      this.isSyncingFromProp = true;
      this.localValue = this.toDate(value);
      this.$nextTick(() => {
        this.isSyncingFromProp = false;
      });
    },
  },
  watch: {
    value(value) {
      this.syncFromProp(value);
    },
    localValue(value){
      if (this.isSyncingFromProp) return;
      this.$emit('input', value ? this.toString(value) : null);
    }
  },
}
</script>

<style>
.dp__main{
  width: 100%;
  font-family: inherit;
  position: relative;
}
.dp__input.w-input.w-in {
  height: 44px;

  border: 1px solid var(--blue-dark);
}

.dp__input.w-input {
  display: block;
  width: 100%;
  height: 38px;
  padding: 8px 12px;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #333333;
  vertical-align: middle;
  background-color: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 0;
  font-family: inherit;
}

.dp__main .dp__input.w-input.dp__input_icon_pad {
  padding-left: 35px;
}

</style>